// library imports
import { useState } from "react";
// hook imports
import useFetch from "./useFetch";

export default function useHasPvPowerMeter() {
  const [fetchWrapper] = useFetch();

  // loading state
  const [getHasPvPowerMeterLoading, setGetHasPvPowerMeterLoading] =
    useState(false);

  // this state is to check whether the site has PV power meter
  const [hasPvPowerMeter, setHasPvPowerMeter] = useState(false);

  /* API to check whether site has PV power meter that is selected and not deleted */
  function getHasPvPowerMeter({ siteSelected }) {
    setGetHasPvPowerMeterLoading(true);
    fetchWrapper({
      endpoint_url: "layout/getHasPvPowerMeter",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
      },
      onSuccess: (response) => {
        setGetHasPvPowerMeterLoading(false);
        setHasPvPowerMeter(response.data);
      },
    });
  }

  return [hasPvPowerMeter, getHasPvPowerMeter, getHasPvPowerMeterLoading];
}
